/**
 * Dietary Icons System
 * Displays dietary information icons on product cards and pages
 */

class DietaryIcons {
  constructor() {
    this.iconMap = {
      'dietary:hasnuts': {
        icon: '🥜',
        label: 'Contains Nuts',
        order: 1
      },
      'dietary:hasgluten': {
        icon: '🌾',
        label: 'Contains Gluten',
        order: 2
      },
      'dietary:vegan': {
        icon: '🌿',
        label: 'Vegan',
        order: 3
      },
      'dietary:glutenfree': {
        icon: '🧘‍♀️',
        label: 'Gluten-Free',
        order: 4
      },
      'dietary:vegetarian': {
        icon: '🥬',
        label: 'Vegetarian',
        order: 5
      },
      'dietary:hasdairy': {
        icon: '🥛',
        label: 'Contains Dairy',
        order: 6
      },
      'dietary:seafood': {
        icon: '🐟',
        label: 'Contains Seafood',
        order: 7
      }
    };

    this.init();
  }

  init() {
    // Initialize icons on page load
    this.renderProductCardIcons();
    this.renderProductPageIcons();
  }

  /**
   * Get dietary tags from product element
   */
  getDietaryTags(element) {
    const tagsAttr = element.getAttribute('data-product-tags');
    if (!tagsAttr) return [];

    const tags = tagsAttr.split(',').map(tag => tag.trim().toLowerCase());
    return tags.filter(tag => tag.startsWith('dietary:'));
  }

  /**
   * Create icon HTML with tooltip
   */
  createIconHTML(tag) {
    const info = this.iconMap[tag];
    if (!info) return '';

    return `
      <span class="dietary-icon" data-tooltip="${info.label}" data-order="${info.order}">
        <span class="dietary-icon__emoji">${info.icon}</span>
        <span class="dietary-icon__tooltip">${info.label}</span>
      </span>
    `;
  }

  /**
   * Render icons on product cards (collection pages)
   */
  renderProductCardIcons() {
    const productCards = document.querySelectorAll('[data-product-card]');

    productCards.forEach(card => {
      const tags = this.getDietaryTags(card);
      if (tags.length === 0) return;

      // Find the image container
      const imageContainer = card.querySelector('.product-card__image');
      if (!imageContainer) return;

      // Check if icons already rendered
      if (card.querySelector('.dietary-icons--card-overlay')) return;

      // Create icons container
      const iconsContainer = document.createElement('div');
      iconsContainer.className = 'dietary-icons dietary-icons--card-overlay';

      // Sort tags by order and create icons
      const sortedTags = tags.sort((a, b) => {
        const orderA = this.iconMap[a]?.order || 999;
        const orderB = this.iconMap[b]?.order || 999;
        return orderA - orderB;
      });

      sortedTags.forEach(tag => {
        iconsContainer.innerHTML += this.createIconHTML(tag);
      });

      // Add icons as overlay on image (left side, vertically stacked)
      imageContainer.style.position = 'relative';
      imageContainer.appendChild(iconsContainer);
    });
  }

  /**
   * Render icons on product page (detail page)
   */
  renderProductPageIcons() {
    const productPage = document.querySelector('[data-product-page]');
    if (!productPage) return;

    const tags = this.getDietaryTags(productPage);
    if (tags.length === 0) return;

    // Check if icons already rendered
    if (productPage.querySelector('.dietary-icons')) return;

    // Find the title element (to place icons near it)
    const titleElement = productPage.querySelector('.product-template__title, h1');
    if (!titleElement) return;

    // Create icons container
    const iconsContainer = document.createElement('div');
    iconsContainer.className = 'dietary-icons dietary-icons--product-page';

    // Sort tags by order and create icons
    const sortedTags = tags.sort((a, b) => {
      const orderA = this.iconMap[a]?.order || 999;
      const orderB = this.iconMap[b]?.order || 999;
      return orderA - orderB;
    });

    sortedTags.forEach(tag => {
      iconsContainer.innerHTML += this.createIconHTML(tag);
    });

    // Insert icons after the title element (as a sibling, not disrupting layout)
    titleElement.insertAdjacentElement('afterend', iconsContainer);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new DietaryIcons();
  });
} else {
  new DietaryIcons();
}

// Re-initialize when products are dynamically loaded
document.addEventListener('products:loaded', () => {
  new DietaryIcons();
});
